module.exports = __webpack_public_path__ + "assets/img/case1.758c834e.png";